import { Lightbox, MediaContainer } from '@design-system';
import * as React from 'react';

import { ImageSizes } from '../../../helpers/images';
import { VideoStoryblok } from '../../../types/generated-storyblok';
import { TrackMultiMediaClick } from '../../../utils/analytics';
import { storyblokMediaItemToLightboxEntry } from '../../../utils/lightbox';
import { Image } from '../../Image';

type Props = {
  analytics?: Analytics;
  blok: VideoStoryblok;
  coverImageSize: ImageSizes;
  showTitle?: boolean;
};

export const ArtistVideo: React.FC<Props> = ({
  analytics,
  blok,
  coverImageSize,
  showTitle = true,
}) => {
  if (
    !blok.coverImage?.filename ||
    !blok.vimeo?.vimeo_oembed?.response?.video_id
  ) {
    return null;
  }

  return (
    <Lightbox items={[storyblokMediaItemToLightboxEntry(blok, 0)]}>
      {(lightbox) => (
        <MediaContainer
          duration={blok.vimeo.vimeo_oembed.response.duration}
          mediaComponent={
            <Image
              alt={blok.coverImage.alt || ''}
              className="overflow-hidden rounded-sm"
              focus={blok.coverImage.focus}
              hoverEffect
              size={coverImageSize}
              src={blok.coverImage.filename}
            />
          }
          onClick={() => {
            lightbox.openOnSlide(0);
            if (analytics) {
              TrackMultiMediaClick({
                page: analytics.page,
                context: analytics.context,
                pageTitle: analytics.pageTitle,
                type: 'video',
                title: blok.vimeo?.vimeo_oembed?.response?.title,
                durationInSeconds: blok.vimeo?.vimeo_oembed?.response?.duration,
              });
            }
          }}
          title={showTitle ? blok.title : undefined}
          type="Video"
        />
      )}
    </Lightbox>
  );
};
